import React from 'react';
import { Input } from '../ui/input';

const AltTextSection = ({ alt, onAltChange }) => (
  <div className="space-y-3">
    <h3 className="font-semibold text-sm">Texto Alternativo</h3>
    <Input type="text" value={alt} onChange={onAltChange} placeholder="Descripción de la imagen" />
  </div>
);

export default AltTextSection;
